module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/waste-glass-bottle2/font/AmwayIcons.ttf?5v2gxx
// module id = r1uV
// module chunks = 0